let selectors = {
  input: '.js-qty__num',
  plus: '.js-qty__adjust--plus',
  minus: '.js-qty__adjust--minus'
}

export default class QtySelector {
  constructor(el, options) {
    this.wrapper = el
    this.plus = el.querySelector(selectors.plus)
    this.minus = el.querySelector(selectors.minus)
    this.input = el.querySelector(selectors.input)
    this.minValue = Number(this.input.getAttribute('min')) || 1
    this.step = Number(this.input.getAttribute('step')) || 1

    let defaults = {
      namespace: null,
      isCart: false,
      key: this.input.dataset.id
    }

    this.options = Object.assign({}, defaults, options)

    this.init()
  }

  init() {
    this.plus.addEventListener(
      'click',
      function (evt) {
        let qty = this._getQty()
        this._change(evt, qty + this.step)
      }.bind(this)
    )

    this.minus.addEventListener(
      'click',
      function (evt) {
        let qty = this._getQty()
        this._change(evt, qty - this.step)
      }.bind(this)
    )

    this.input.addEventListener(
      'change',
      function (evt) {
        this._change(evt, this._getQty())
      }.bind(this)
    )
  }

  _getQty() {
    let qty = this.input.value
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to this.minValue.
      qty = this.minValue
    }
    return parseInt(qty)
  }

  _change(evt, qty) {
    if (qty <= this.minValue || qty % this.step !== 0) {
      qty = this.minValue
    }

    this.input.value = qty

    if (document.body.classList.contains('template-product') && evt?.target.closest('.product-grid__container')) this._updateSubtotalPriceBasedOnQty(qty);
    
    if (this.options.isCart) {
      document.dispatchEvent(
        new CustomEvent('cart:quantity' + this.options.namespace, {
          detail: [this.options.key, qty, this.wrapper]
        })
      )
    }
  }

  _updateSubtotalPriceBasedOnQty(qty) {
    if(document.querySelector('#sub__total--block-price')) {
      const unitPrice = parseInt(document.querySelector('#sub__total--block-price .product__price').getAttribute("data-product-price"));
      const subtotalPrice = theme.Currency.formatMoney(qty*unitPrice, theme.settings.moneyFormat);
      document.querySelector('#product__price--subtotal').textContent = subtotalPrice;
    }
  }
}
